import { render, staticRenderFns } from "./Composite.vue?vue&type=template&id=11daceda&"
import script from "./Composite.vue?vue&type=script&lang=js&"
export * from "./Composite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports